import { Box, Chip, Typography } from '@mui/material';
import CustomButton from 'components/shared/CustomButton/CustomButton';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { ZoomInfoService } from 'service/zoominfo.service';
import { useAppSelector } from 'store/hooks';
import zeplinColor from 'theme/Color';
import About from './About/About';
import ContactCard from './ContactCard/ContactCard';
import ImportantCard from './ImportantCard/ImportantCard';
import ListTagsCard from './ListTagCard/ListTagsCard';
import RecentSignal from './RecentSignal/RecentSignal';
import styles from './styles.module.css';

const Overview = ({
  data,
  setValue,
}: {
  data: any;
  setValue: React.Dispatch<React.SetStateAction<number>>;
}) => {
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [signalData, setSignalData] = useState<any>([]);
  const [contactoading, setContactLoading] = useState(false);
  const [contactData, setContactData] = useState<any>([]);
  const role = useAppSelector((state) => state.auth.role);
  const isAdmin = role?.includes('super_admin');

  const getCompanySignals = async (id = '', page = 1) => {
    try {
      setLoading(true);
      const res = await ZoomInfoService.getCompanySignals(id, page);
      console.log(res);
      setSignalData(res?.items);
    } catch {
    } finally {
      setLoading(false);
    }
  };

  const getCompanyContact = async (id = '', page = 1) => {
    try {
      setContactLoading(true);
      const res = await ZoomInfoService.getCompanyEmployees(id, page?.toString());
      console.log(res);
      setContactData(res?.data?.items);
    } catch {
    } finally {
      setContactLoading(false);
    }
  };

  useEffect(() => {
    getCompanySignals(location?.pathname.split('/')[2] || '');
    getCompanyContact(location?.pathname.split('/')[2] || '');
  }, [location?.pathname.split('/')[2]]);

  return (
    <Box
      sx={{
        display: 'flex',
        gap: { xs: '20px', xl: '32px' },
        height: 'calc(100vh - 310px)',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '16px', xl: '24px' },
          flex: 1,
          height: '100%',
          overflowY: 'scroll',
        }}
      >
        {isAdmin && (
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '8px', xl: '16px' } }}>
            <Typography variant='responsiveHeading3'>Lists</Typography>
            <ListTagsCard isTargeted={data?.isTargeted} data={data?.item} />
          </Box>
        )}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '8px', xl: '16px' },
            flex: 4,
            overflowY: 'scroll',
          }}
        >
          <Typography variant='responsiveHeading3'>Company Details</Typography>
          <Box
            sx={{
              border: `1px solid ${zeplinColor.Neutral5}`,
              flex: 1,
              borderRadius: '14px',
              padding: '16px',
              overflowY: 'scroll',
            }}
          >
            <About data={data?.item} loading={loading} />
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '16px', xl: '24px' },
          flex: 1,
          paddingBottom: '2rem',
          overflowY: 'scroll',
        }}
      >
        <Box
          sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '8px', xl: '16px' }, flex: 2 }}
        >
          <Typography variant='responsiveHeading3'>Important to Know</Typography>
          <ImportantCard data={data?.importantToKnow} loading={loading} />
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '8px', xl: '16px' },
            flex: 2,
          }}
        >
          <Typography variant='responsiveHeading3'>Signals</Typography>
          <RecentSignal data={signalData} loading={loading} />
        </Box>
        <Box
          sx={{ display: 'flex', flexDirection: 'column', gap: { xs: '8px', xl: '16px' }, flex: 2 }}
        >
          <Typography variant='responsiveHeading3'>Intelligence Feed</Typography>
          {!data?.intelligenceFeed?.length && !loading ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',

                gap: '32px',
              }}
            >
              {' '}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '24px',
                  width: '100%',
                }}
              >
                <img src={'/assets/no-zoominfo.svg'} className={styles['no-target-icon']} />
                <Typography
                  variant='responsiveHeading3'
                  color={zeplinColor.BasicBlack}
                  sx={{ marginTop: '0px' }}
                >
                  No feeds available.
                </Typography>
              </Box>
            </Box>
          ) : (
            data?.intelligenceFeed?.map((val: any) => (
              <a
                href={`${val?.url ?? ''}`}
                rel='noopener noreferrer'
                target='_blank'
                style={{ textDecoration: 'none', color: zeplinColor.BasicBlack, cursor: 'pointer' }}
              >
                <Box
                  sx={{
                    borderRadius: '14px',
                    border: `1px solid ${zeplinColor.Neutral5}`,
                    padding: '16px',
                    display: 'flex',
                    gap: '16px',
                  }}
                >
                  <Box
                    sx={{
                      borderRadius: '8px',
                      height: '80px',
                      width: '80px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      backgroundColor: zeplinColor.Neutral3,
                      padding: '10px',
                    }}
                  >
                    <img
                      src={'/assets/no-news.svg'}
                      width='80px'
                      height='80px'
                      alt='zoominfo-no-news'
                      style={{ objectFit: 'contain' }}
                    />
                  </Box>

                  <Box sx={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                    <Box
                      sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                      }}
                    >
                      <Chip
                        label={
                          <Typography
                            variant='responsiveLabel1'
                            sx={{ display: 'flex', alignItems: 'center' }}
                            color={zeplinColor.BasicBlack}
                          >
                            {val?.subCategory}
                          </Typography>
                        }
                        sx={{
                          backgroundColor: zeplinColor.Neutral5,
                          color: zeplinColor.Neutral1,
                          '&.MuiChip-root': {
                            height: '24px',
                            padding: '5px 12px',
                            borderRadius: '50px',
                          },
                          '& .MuiChip-label': {
                            padding: 0,
                          },
                        }}
                      />
                      <Typography variant='responsiveLabel1' color={zeplinColor.Neutral8}>
                        {dayjs(val?.date).format('DD MMM, YYYY')}
                      </Typography>
                    </Box>
                    <Typography sx={{ fontWeight: 505, fontSize: '14px' }}>{val?.title}</Typography>
                  </Box>
                </Box>
              </a>
            ))
          )}
        </Box>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: { xs: '16px', xl: '24px' },
          flex: 1,
        }}
      >
        {' '}
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '8px', xl: '16px' },
            flex: 3,
            minHeight: 0,
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant='responsiveHeading3'>Recommended Contacts</Typography>
            <CustomButton
              disabled={false}
              onClick={() => {
                setValue(1);
              }}
              variant='outlined'
              color='secondary'
              style={{
                borderRadius: 50,
                height: 32,
                textAlign: 'center',
                gap: '16px',
              }}
              textStyle={{ color: zeplinColor.BasicBlack }}
              text={'See All'}
              icon={''}
              buttonVariant='buttonSmall'
            />
          </Box>
          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px',
              overflowY: 'scroll',
            }}
          >
            {contactoading ? (
              [1, 2, 3, 4, 5, 6].map((val: any) => (
                <ContactCard data={val} loading={contactoading} />
              ))
            ) : !contactData?.length ? (
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '32px',
                }}
              >
                {' '}
                <Box
                  sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    gap: '24px',
                    width: '100%',
                  }}
                >
                  <img src={'/assets/no-zoominfo.svg'} className={styles['no-target-icon']} />
                  <Typography
                    variant='responsiveHeading3'
                    color={zeplinColor.BasicBlack}
                    sx={{ marginTop: '0px' }}
                  >
                    No Recommended contacts
                  </Typography>
                </Box>
              </Box>
            ) : (
              contactData?.map((val: any) => <ContactCard data={val} loading={contactoading} />)
            )}
          </Box>
        </Box>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: { xs: '8px', xl: '16px' },
            flex: 2,
            minHeight: 0,
          }}
        >
          <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant='responsiveHeading3'>Similar Companies</Typography>
            <CustomButton
              disabled={false}
              onClick={() => {
                setValue(3);
              }}
              variant='outlined'
              color='secondary'
              style={{
                borderRadius: 50,
                height: 32,
                textAlign: 'center',
                gap: '16px',
              }}
              textStyle={{ color: zeplinColor.BasicBlack }}
              text={'See All'}
              icon={''}
              buttonVariant='buttonSmall'
            />
          </Box>
          {!data?.item?.competitors?.length ? (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '32px',
              }}
            >
              {' '}
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  gap: '24px',
                  width: '100%',
                }}
              >
                <img src={'/assets/no-zoominfo.svg'} className={styles['no-target-icon']} />
                <Typography
                  variant='responsiveHeading3'
                  color={zeplinColor.BasicBlack}
                  sx={{ marginTop: '0px' }}
                >
                  No Similar companies.
                </Typography>
              </Box>
            </Box>
          ) : (
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: { xs: '8px', xl: '16px' },
                overflowY: 'scroll',
                paddingBottom: '2rem',
              }}
            >
              {data?.item?.competitors?.map(
                (val: any, ind: number) =>
                  ind <= 2 && (
                    <Link
                      to={`/zoominfo/${val?.id ?? ''}`}
                      style={{ textDecoration: 'none', color: zeplinColor.BasicBlack }}
                    >
                      <Box
                        sx={{
                          borderRadius: '14px',
                          padding: '12px',
                          display: 'flex',
                          justifyContent: 'space-between',
                          backgroundColor: zeplinColor.Neutral3,
                          ':hover': {
                            backgroundColor: zeplinColor.Neutral4,
                          },
                          alignItems: 'center',
                        }}
                      >
                        <Box
                          sx={{
                            display: 'flex',
                            gap: '12px',
                            alignItems: 'center',
                          }}
                        >
                          <Box
                            sx={{
                              width: '48px',
                              height: '48px',
                              borderRadius: '8px',
                              backgroundColor: zeplinColor.Neutral1,
                            }}
                          >
                            <img
                              src={val?.logo}
                              width='48px'
                              height='48px'
                              alt='industry'
                              style={{ objectFit: 'contain', borderRadius: '8px' }}
                              onError={(e) => {
                                e.currentTarget.onerror = null;
                                e.currentTarget.src = '/assets/zoominfo-fallback.svg';
                              }}
                            />
                          </Box>
                          <Typography sx={{ fontSize: '18px' }} color={zeplinColor.BasicBlack}>
                            {val?.name}
                          </Typography>
                        </Box>
                        <Box
                          sx={{
                            width: '24px',
                            height: '24px',
                            backgroundColor: zeplinColor.Neutral10,
                            borderRadius: '50px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                          }}
                        >
                          <img src='/assets/arrow-next-white.svg' alt='arrow-next' />
                        </Box>
                      </Box>
                    </Link>
                  ),
              )}
            </Box>
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Overview;
